<style>
@keyframes gradientWave {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.hover\:before\:animate-gradientWave:hover::before {
  animation: gradientWave 2s ease infinite;
}
</style>

<script setup>
import GainReward from "~/assets/img/landing/gain-reward.svg";
import Portfolio from "~/assets/img/landing/portfolio.svg";
import GrowCareer from "~/assets/img/landing/grow-career.svg";
import Convient from "~/assets/img/landing/convient.svg";
import ApplicationReward from "~/assets/img/landing/reward.svg";
import PersonalizedAssistance from "~/assets/img/landing/pa.svg";
import StudentInquiry from "~/assets/img/landing/inquiry.svg";
import SupportResource from "~/assets/img/landing/support.svg";

import Utcc from "~/assets/img/uni-logo/utcc.png";
import Aihm from "~/assets/img/uni-logo/aihm.png";
import Assumption from "~/assets/img/uni-logo/assumption.png";
import Bangkok from "~/assets/img/uni-logo/bangkok.png";
import Dpu from "~/assets/img/uni-logo/dpu.png";
import GlobalAcademy from "~/assets/img/uni-logo/global-academy.png";
import HarbourSpace from "~/assets/img/uni-logo/harbour-space.png";

import Krirk from "~/assets/img/uni-logo/krirk.png";
import Panyapiwat from "~/assets/img/uni-logo/panyapiwat.png";
import Raffles from "~/assets/img/uni-logo/raffles.png";
import Rangsit from "~/assets/img/uni-logo/rangsit.png";
import Sbu from "~/assets/img/uni-logo/sbu.png";
import Sfu from "~/assets/img/uni-logo/sfu.png";
import Shinawatra from "~/assets/img/uni-logo/shinawatra.png";
import Siam from "~/assets/img/uni-logo/siam.png";
import StTeresa from "~/assets/img/uni-logo/st-teresa.png";
import Stamford from "~/assets/img/uni-logo/stamford.png";
import Kasem from "~/assets/img/uni-logo/kasem.png";
import Dusit from "~/assets/img/uni-logo/dusit.png";

import GetStarted from "~/assets/img/get-started-banner.svg";
import WithoutLinky from "~/assets/img/without-linky.png";

import Explore from "~/assets/img/icon/explore.svg";
import Percent from "~/assets/img/icon/percent.svg";
import Envelope from "~/assets/img/icon/accept.svg";
import Upload from "~/assets/img/icon/upload.svg";

definePageMeta({
  layout: "empty",
  auth: false,
});

const eduJourney = ref([
  {
    title: "Build Personal Growth",
    desc: "By guiding others, mentors develop communication, empathy, and leadership — qualities that stand out in any job or grad school application.",
    icon: Percent,
  },
  {
    title: "Develop Valuable Skills",
    desc: "By helping others, you’ll strengthen your communication, empathy, and leadership — great for your resume and future career.",
    icon: Upload,
  },
  {
    title: "Build Meaningful Connections",
    desc: "Mentoring creates genuine friendships and a sense of community with fellow students at your university.",
    icon: Envelope,
  },
]);

const uniLogos = [
  Utcc,
  Aihm,
  Assumption,
  Bangkok,
  Dpu,
  GlobalAcademy,
  HarbourSpace,
  Krirk,
  Panyapiwat,
  Raffles,
  Rangsit,
  Sbu,
  Sfu,
  Shinawatra,
  Siam,
  StTeresa,
  Stamford,
  Kasem,
  Dusit,
];

const benefits = [
  {
    img: GainReward,
    title: "💬 Be a Friendly Guide",
    desc: "Answer questions, listen to concerns, and help new students feel less alone as they ",
  },
  {
    img: Portfolio,
    title: "🏠 Talk About Campus Life & Budgeting",
    desc: "Share tips on living expenses, accommodation, food, and what daily life is really like as a student.",
  },
  {
    img: GrowCareer,
    title: "🌱 Support Their Journey",
    desc: "Offer encouragement, check in when they need support, and be the kind of friend you once wished you had.",
  },
  {
    img: Convient,
    title: "✨ Share Your Personal Experience",
    desc: "Share your favorite spots, fun moments, or how you chose your major — your story can inspire someone just starting out.",
  },
];

const mentorShips = [
  {
    img: StudentInquiry,
    title: "Manage Students Easily",
    desc: "Easily manage student profiles, track admission statuses, and organize documentation - in one place. Keep everything accessible and well-organized. ",
  },
  {
    img: PersonalizedAssistance,
    title: "Track Mentorship Progress",
    desc: "Track your mentorship progress including the number of students mentored, successful admissions, earned reward points, and pending rewards.",
  },
  {
    img: ApplicationReward,
    title: "Supporting Materials and Trainings",
    desc: "Access mentorship playbooks and university decks to help you start consultations, understand student needs, and promote yourself as a mentor.",
  },
  {
    img: SupportResource,
    title: "Expand Mentorship Reach",
    desc: "Students who reach out to UniLinks directly can be assigned to you—giving you more opportunities to grow your mentorship, make an impact, and increase your earnings.",
  },
];

const faqs = [
  {
    question: "Who can apply to be a UniLinks student ambassador?",
    answer:
      "Any current university student who wants to share their journey and support others by offering casual advice and helping them feel more connected.",
  },
  {
    question: "What documents are required to become a student ambassador?",
    answer:
      "Basic student verification—usually a student ID or proof of enrollment.",
  },
  {
    question: "What is the onboarding process for student ambassadors?",
    answer:
      "We’ll walk you through a brief introduction so you know how to support new students in a friendly, respectful, and helpful way.",
  },
  {
    question: "How do student ambassadors support new students?",
    answer:
      "They share their personal experiences via call or text, offering honest tips on university life, studying abroad, and adjusting to a new environment—alongside UniLinks’ professional guidance.",
  },
  {
    question: "What support resources are available for student ambassadors?",
    answer:
      "UniLinks provides messaging tips, example talking points, and an ambassador community to keep you supported and informed.",
  },
  {
    question: "How can prospective students connect with student ambassadors?",
    answer:
      "Students first consult with UniLinks. If relevant, they can then be connected to ambassadors with similar study backgrounds for additional insight or peer support.",
  },

  {
    question: "How does UniLinks ensure the quality of student ambassadorship?",
    answer:
      " Ambassadors are guided by UniLinks, and we monitor conversations and feedback to ensure new students receive thoughtful, accurate, and respectful communication.",
  },
];

const { data: sessionData, signOut, status } = useAuth();

const menu = ref();
const items = ref([
  {
    label: "Logout",
    icon: "pi pi-sign-out",
    command: async () => {
      await signOut();
    },
  },
]);

const authUser = computed(() => {
  return sessionData.value?.data;
});

const toggle = (event) => {
  menu.value.toggle(event);
};

const hasScrolled = ref(false);
const container = ref(null);

const onScroll = () => {
  if (container.value) {
    hasScrolled.value = container.value.scrollTop > 20;
  }
};

const config = useRuntimeConfig();
const routeToMentorPortal = (path) => {
  navigateTo(config.public.mentorPortalUrl + path, {
    external: true,
    target: "_blank",
  });
};

onMounted(() => {
  if (container.value) {
    container.value.addEventListener("scroll", onScroll);
  }

  // const img = new Image();
  // img.src = GetStarted;
  // img.onload = () => console.log("image loaded successfully");
  // img.onerror = () => console.error("fail to load the background image");
  // console.log("GetStarted Image string: ", GetStarted);
});

onUnmounted(() => {
  if (container.value) {
    container.value.removeEventListener("scroll", onScroll);
  }
});

useHead({
  link: [{ rel: "canonical", href: "https://unilinks.co/mentor" }],
});

useSeoMeta({
  title: "Become a Student Mentor & Earn Rewards | Join UniLinks Mentoring",
  ogTitle: "Become a Student Mentor & Earn Rewards | Join UniLinks Mentoring",
  description:
    "With UniLinks, become a student mentor and provide education consultations to prospective students. Guide their journey and earn rewards for every successful enrollment you support.",
  ogDescription:
    "With UniLinks, become a student mentor and provide education consultations to prospective students. Guide their journey and earn rewards for every successful enrollment you support.",
  ogImage: META_IMAGE_URL,
  ogUrl: "https://unilinks.co/mentor",
  twitterCard: "summary_large_image",
  twitterTitle:
    "Become a Student Mentor & Earn Rewards | Join UniLinks Mentoring",
  twitterDescription:
    "With UniLinks, become a student mentor and provide education consultations to prospective students. Guide their journey and earn rewards for every successful enrollment you support.",
  twitterImage: META_IMAGE_URL,
});
</script>

<template>
  <div ref="container" class="h-screen overflow-auto">
    <Header />

    <section>
      <div
        class="relative mx-auto px-4 min-h-[550px]"
        :style="{ height: 'calc(100vh - 106px)' }"
      >
        <div class="absolute inset-0">
          <img
            src="~/assets/img/mentor-banner.png"
            alt="Cover Image"
            class="w-full h-full object-cover object-left lg:object-center"
          />
        </div>
        <div
          class="relative z-10 flex flex-col justify-center items-start h-full lg:p-8"
        >
          <div
            class="text-primary w-full md:w-4/5 lg:w-2/3 xl:w-1/2 mt-0 lg:mt-10 text-center lg:text-left"
          >
            <h1
              class="text-4xl lg:text-5xl font-semibold leading-[1.2] lg:leading-[1.2]"
            >
              Connect with <br class="inline-block md:hidden" />
              Future Students. <br />
              Share Your Experience on UniLinks!
            </h1>
            <p class="mt-6 text-base text-gray-700 font-semibold mb-4 lg:mb-12">
              Become a Student Ambassador on UniLinks and support future
              students by sharing your experience. If you're currently studying
              at one of our partner universities, you can offer friendly
              guidance on academics, campus life, and more — helping others make
              better decisions about their education.
            </p>

            <Button
              severity="tertiary"
              label="Become an Ambassador"
              icon="pi pi-arrow-up-right"
              iconPos="right"
              class="relative overflow-hidden px-0 lg:px-10 py-3 !h-[54px] lg:py-5 mt-8 !font-semibold !text-white !bg-[#1C477B] rounded-md border !border-[#1C477B] transition-all duration-300 ease-in-out group before:absolute before:inset-0 before:bg-gradient-to-r before:from-[#1C477B] before:via-[#295E9E] before:to-[#1C477B] before:bg-[length:300%_300%] before:opacity-0 before:transition-opacity before:duration-500 hover:before:opacity-100 hover:before:animate-gradientWave"
              :pt="{
                label: '!font-bold relative z-10 ml-9 lg:ml-0',
                icon: '!font-bold leading-4 mx-0 ml-2 mr-9 lg:mr-0 order-1 relative z-10 bounce-icon',
              }"
              @click="routeToMentorPortal('/signup')"
            >
            </Button>
          </div>
        </div>
      </div>
    </section>

    <div class="lg:container px-4 mx-auto pt-20 lg:pt-28">
      <h2 class="text-4xl lg:text-5xl font-semibold text-slate-900 text-center">
        Be The Senior You Needed!
      </h2>
      <p
        class="text-center text-gray-700 text-base font-semibold mt-5 w-full lg:w-2/3 lg:mx-auto"
      >
        Share what you’ve learned and support new students through their journey
        — just like you once needed when you were starting out.
      </p>

      <div
        class="grid grid-cols-12 gap-y-5 lg:gap-y-10 md:gap-10 mt-10 lg:mt-16 mb-20 justify-center"
      >
        <div
          class="col-span-12 md:col-span-6 lg:col-span-4 h-full"
          v-for="edu in eduJourney"
          :key="edu.title"
        >
          <div
            class="px-6 h-full bg-white border border-slate-200 rounded-2xl py-10 text-center hover:shadow group"
          >
            <div
              class="mx-auto mb-6 w-40 h-40 flex items-center justify-center overflow-visible"
            >
              <img
                :src="edu.icon"
                class="mx-auto h-full object-contain transition-transform duration-300 ease-in-out group-hover:scale-110"
              />
            </div>
            <h5
              class="text-xl font-semibold text-primary-600 transition-transform duration-300 ease-in-out group-hover:-translate-y-2 my-3"
            >
              {{ edu.title }}
            </h5>
            <p class="text-gray-800 text-sm">{{ edu.desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- our partner universities -->
    <section class="pb-8 lg:pb-16" id="partnerships">
      <div class="px-4">
        <div class="lg:container mx-auto pt-12">
          <div class="text-center mb-16">
            <p
              class="px-3 py-1 rounded-full bg-[#F5F9FF] text-[#295BAC] text-sm inline-block"
            >
              Partnerships
            </p>
            <h2
              class="text-center text-4xl lg:text-4xl font-semibold mt-4 text-[#101828]"
            >
              Partner Universities in Thailand
            </h2>
            <p
              class="text-center text-gray-700 text-base font-semibold mt-5 w-full lg:w-2/3 lg:mx-auto"
            >
              If you’re studying at one of these universities, you can become a
              student mentor, guide others, and earn rewards.
            </p>
          </div>

          <!-- <div class="flex justify-center gap-8 flex-wrap items-center">
            <img
              v-for="(logo, index) in uniLogos"
              :key="'uni-logo_' + index"
              :src="logo"
              class="w-auto h-10 max-w-32"
            />
          </div> -->
          <div class="flex justify-center gap-8 flex-wrap items-center">
            <img
              v-for="(logo, index) in uniLogos"
              :key="'uni-logo_' + index"
              :src="logo"
              class="w-auto h-10 object-contain max-w-32 cursor-pointer transition-transform duration-300 ease-in-out hover:scale-110 hover:opacity-80"
              alt="University Logo"
            />
          </div>
          <div
            class="flex justify-center gap-8 flex-wrap items-center mt-2 lg:mt-12"
          >
            <Button
              severity="tertiary"
              label="Become a Student Mentor"
              icon="pi pi-arrow-up-right"
              iconPos="right"
              class="relative overflow-hidden px-6 lg:px-6 py-3.5 !h-[54px] text-lg lg:py-5 mt-8 !font-bold !text-[#1C477B] !bg-[#00EDD0] rounded-md border border-[#00EDD0] transition-all duration-300 ease-in-out group before:absolute before:inset-0 before:bg-gradient-to-r before:from-[#00EDD0] before:via-[#00CDBB] before:to-[#00EDD0] before:bg-[length:300%_300%] before:opacity-0 before:transition-opacity before:duration-500 hover:before:opacity-100 hover:before:animate-gradientWave"
              :pt="{
                label: '!font-bold relative z-10',
                icon: '!font-bold leading-4 mx-0 ml-2 order-1 relative z-10 bounce-icon',
              }"
              @click="routeToMentorPortal('/signup')"
            >
            </Button>
          </div>
        </div>
      </div>
    </section>
    <!-- <hr class="max-w-screen-lg mx-auto shadow-md bg-gray-600 mt-8 mb-10" /> -->

    <!-- Benefits section -->
    <section class="py-12" id="benefits">
      <div class="max-w-screen-xl mx-auto px-8 mt-8">
        <div class="text-center mb-10">
          <p
            class="px-3 py-1 rounded-full bg-[#F5F9FF] text-[#295BAC] text-sm inline-block"
          >
            Responsibility
          </p>
          <h2
            class="text-center text-4xl lg:text-4xl font-semibold mt-4 text-[#101828]"
          >
            Make An Impact With Your Experience.
          </h2>
          <p
            class="text-center text-gray-700 text-base font-semibold mt-5 w-full lg:w-2/3 lg:mx-auto"
          >
            Your student experience is valuable for the new students. Be the
            guiding star in the new journey and era of the students.
          </p>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div
            v-for="(benefit, index) in benefits"
            :key="'benefits_' + index"
            class="bg-white rounded-lg shadow overflow-hidden border py-10 px-8 border-[#D7DAE8] text-center lg:text-left transition duration-300 ease-in-out hover:shadow-lg hover:border-[#00EDD0] hover:bg-gradient-to-b hover:from-white hover:to-[rgba(0,237,208,0.2)] hover:via-white hover:bg-[70%]"
          >
            <img
              :src="benefit.img"
              :alt="benefit.title"
              class="object-cover h-auto mx-auto lg:mx-0"
            />
            <div class="space-y-2 mt-6">
              <p
                class="text-xl font-semibold text-primary-600 transition-colors duration-300 ease-in-out hover:text-[#1C477B]"
              >
                {{ benefit.title }}
              </p>
              <p
                class="text-sm text-gray-900 transition-colors duration-300 ease-in-out hover:text-[#1C477B]"
              >
                {{ benefit.desc }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="py-6 lg:py-12 pb-20 relative" id="features">
      <div class="max-w-screen-xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-10">
          <p
            class="px-3 py-1 rounded-full bg-[#F5F9FF] text-[#295BAC] text-sm inline-block"
          >
            Features
          </p>
          <h2
            class="text-center text-4xl lg:text-4xl font-semibold mt-4 text-[#101828]"
          >
            Messy Spreadsheets? Not Anymore.
          </h2>
          <p
            class="text-center text-gray-500 text-base lg:text-xl font-normal mt-5 w-full lg:w-2/3 lg:mx-auto"
          >
            Manage student inquiries, provide guidance, track applications,
            access resources, and monitor rewards—all in one place.
          </p>
        </div>

        <div class="flex justify-center items-center relative">
          <img
            src="~/assets/img/mentorship.png"
            alt="mentorship"
            class="w-full object-cover"
          />
        </div>
      </div>

      <div class="max-w-screen-xl mx-auto px-4">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
          <div
            v-for="mentorShip in mentorShips"
            class="bg-transparent overflow-hidden py-4 px-6 border border-gray-200 text-center lg:text-left group transition-all duration-300 ease-in-out hover:shadow-md rounded-lg"
          >
            <img
              :src="mentorShip.img"
              alt="Card Image"
              class="w-[80px] h-[80px] object-contain mx-auto lg:mx-0 transition-transform duration-300 ease-in-out group-hover:rotate-12"
            />

            <div class="mt-6">
              <p class="text-xl font-semibold text-primary-600">
                {{ mentorShip.title }}
              </p>
              <p class="text-gray-800 text-sm mt-2 mb-4">
                {{ mentorShip.desc }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="px-8 py-10 lg:py-24 bg-[#F9FAFB]" id="who-can-apply">
      <div class="max-w-screen-xl mx-auto">
        <!-- Header Section -->
        <div class="mb-5">
          <p class="text-primary-500 font-semibold text-base lg:text-base">
            Become a Student Ambassador and Help The Next Generation!
          </p>
          <h2 class="text-4xl lg:text-4xl my-3 font-semibold text-slate-900">
            What are the criteria?
          </h2>
        </div>

        <!-- Description Section -->
        <ul
          class="mt-4 lg:mt-6 text-gray-800 space-y-2 list-disc pl-4 font-normal text-base lg:text-base"
        >
          <li>
            Must be a current student or an alumnus from our partnered
            university.
          </li>
          <li>Must not be affiliated with any education agencies.</li>
          <li>Must have strong communication skills.</li>
          <li>Must have willingness to help.</li>
        </ul>
        <br />

        <!-- Image Section -->
        <div
          class="mt-4 lg:mt-8 w-full h-44 lg:h-[315px] mx-auto border rounded-lg overflow-hidden"
        >
          <img
            src="~/assets/img/student-group.png"
            alt="Students discussing"
            class="w-full h-full object-cover"
          />
        </div>
        <!-- Next Steps Section -->
        <div class="mt-12 lg:mt-16 grid grid-cols-2 gap-6">
          <h3
            class="col-span-2 lg:col-span-1 text-3xl lg:text-4xl font-semibold text-gray-900"
          >
            I am interested, what is next?
          </h3>

          <!-- right: Onboarding Process -->
          <div class="col-span-2 lg:col-span-1 pt-2">
            <h4 class="text-lg font-semibold mb-4 text-gray-900">
              Onboarding Process
            </h4>
            <ol
              class="text-base lg:text-base list-decimal pl-4 text-gray-800 space-y-2"
            >
              <li>Click to register your interest.</li>
              <li>Provide your personal information.</li>
              <li>Enter your academic details.</li>
              <li>Share your work experience.</li>
              <li>Start connecting with students as prospective students.</li>
              <li>Wait for approval from the UniLinks team.</li>
              <li>After approval, begin consulting prospective students.</li>
            </ol>

            <hr class="my-8" />

            <!-- Right: Required Documents -->
            <div class="mt-6">
              <h4 class="text-lg font-semibold text-gray-900">
                Required Documents for Current Students
              </h4>
              <ul
                class="text-base lg:text-base list-decimal pl-4 text-gray-800 space-y-2 mt-2"
              >
                <li>
                  A valid student ID or enrollment verification letter from
                  their university.
                </li>
                <li>Your CV/Resume</li>
              </ul>

              <h5 class="text-lg font-semibold text-gray-900 mt-7">
                Required Documents for Alumni
              </h5>
              <ul
                class="text-base lg:text-base list-decimal pl-4 text-gray-800 space-y-2 mt-2"
              >
                <li>A copy of their graduation certificate or transcript.</li>
                <li>Your CV/Resume.</li>
              </ul>
              <br />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- video contant page -->
    <section class="py-10 lg:py-16" id="success-story">
      <div
        class="grid grid-cols-2 max-w-screen-xl mx-auto px-4 md:px-6 lg:px-8"
      >
        <div
          class="col-span-2 lg:col-span-1 py-2 px-2 border-gray-200 overflow-hidden lg:pr-16"
        >
          <p class="text-primary-500 font-semibold text-base lg:text-base">
            Inspiring Journeys
          </p>
          <h2 class="text-3xl lg:text-4xl font-semibold mt-4 text-[#101828]">
            Hear From Our Student Ambassadors
          </h2>
          <p
            class="text-gray-800 mt-2 lg:mt-4 font-normal text-base lg:text-base"
          >
            Discover how our student ambassadors play a meaningful role in
            supporting new students—offering real guidance, sharing personal
            insights, and making the university journey less overwhelming for
            others.
          </p>
        </div>
        <div class="col-span-2 lg:col-span-1 space-y-6 mt-2">
          <div class="flex items-start gap-4 py-2 px-2 border-gray-200">
            <div
              class="w-12 h-12 lg:p-3 p-1 flex items-center justify-center flex-shrink-0"
            >
              <span class="text-3xl">🌱</span>
            </div>
            <div>
              <label
                class="text-lg lg:text-lg block font-semibold text-primary-800"
              >
                Starting as a Student Ambassador</label
              >
              <p class="mt-2 text-gray-800 text-base lg:text-base">
                As a student ambassador, I had the chance to help new students
                navigate the challenges I once faced myself—from choosing a
                university to adjusting to student life. It gave me purpose and
                reminded me how far I’ve come.
              </p>
            </div>
          </div>
          <div class="flex items-start gap-4 py-2 px-2 border-gray-200">
            <div
              class="w-12 h-12 lg:p-3 p-1 flex items-center justify-center flex-shrink-0"
            >
              <span class="text-3xl">💬</span>
            </div>
            <div>
              <label class="text-lg block font-semibold text-primary-800"
                >Creating a Positive Impact
              </label>
              <p class="mt-2 text-gray-800 text-base lg:text-base">
                Sometimes, a simple conversation can make a big difference. It
                feels incredibly fulfilling to be the person I wish I had when I
                started—someone who listens, understands, and shares real
                advice.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-12 px-4 pb-0">
        <div class="max-w-screen-xl mx-auto w-full lg:w-2/3 h-60 lg:h-[432px]">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/DlggG8ouWTI"
            title="Unilinks - Student Mentor at UTCCiSM"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div class="pt-4 lg:pt-8 mt-2 text-center">
          <h2 class="text-lg font-medium text-gray-900">
            Ei Shinn Thant | A Student Ambassador at UniLinks
          </h2>
          <p class="text-gray-500 mt-2 text-sm lg:text-base">
            BBA in International Business Management Student <br />
            University of the Thai Chamber of Commerce
          </p>
        </div>
      </div>
    </section>

    <!-- Become a mentor and impact student lives card -->
    <section class="py-6 lg:py-12 px-4">
      <div class="max-w-screen-xl mx-auto">
        <div
          class="hidden lg:flex bg-cover rounded-lg pt-12 pb-8 pl-32 pr-4 lg:px-14 lg:py-14 gap-8 h-fit lg:h-[280px] justify-end lg:bg-left shadow"
          :style="{ backgroundImage: `url(${GetStarted})` }"
        >
          <div class="w- md:w-3/5 lg:w-3/5">
            <h2 class="text-lg lg:text-2xl text-primary-500 font-bold">
              Become a student ambassador and support future students.
            </h2>
            <p
              class="text-sm lg:text-lg lg:font-semibold text-gray-800 mt-0 lg:mt-4 block leading-6"
            >
              Join a growing community of 70+ student ambassadors at UniLinks
              who guide, inspire, and share real advice to help new students
              start strong.
            </p>
            <div
              class="flex flex-wrap gap-2 lg:gap-3 items-start lg:items-center mt-4 lg:mt-6"
            >
              <button
                class="bg-white px-3 py-2 text-sm lg:text-base lg:px-5 lg:py-3 rounded-lg hover:drop-shadow-sm text-primary-500 font-bold"
                @click="routeToMentorPortal('/signup')"
              >
                Be Our Student Ambassador
              </button>
              <button
                class="bg-primary-500 text-white px-3 py-2 text-sm lg:text-base lg:px-5 lg:py-3 rounded-lg hover:bg-primary-600 font-semibold"
                @click="routeToMentorPortal('/signin')"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>

        <div
          class="flex lg:hidden bg-cover rounded-lg pt-16 pb-8 px-8 gap-8 h-fit justify-end"
          :style="{
            backgroundImage: `url(${WithoutLinky})`,
            backgroundPosition: 'top center',
          }"
        >
          <div class="w-full md:w-3/5 lg:w-3/5">
            <h2 class="text-lg lg:text-3xl text-primary-500 font-semibold">
              Become a mentor and impact student lives.
            </h2>
            <p
              class="text-sm lg:text-xl text-[#333] font-medium mt-0 lg:mt-4 block leading-6 lg:leading-8"
            >
              Join over 70+ student mentors already growing with UniLinks.
            </p>
            <div
              class="flex flex-wrap gap-2 lg:gap-3 items-start lg:items-center mt-4 lg:mt-6"
            >
              <button
                class="bg-white px-3 py-2 text-sm lg:text-base lg:px-5 lg:py-3 rounded-lg hover:drop-shadow-sm text-primary-500 font-semibold"
                @click="routeToMentorPortal('/signup')"
              >
                Be Our Student Mentor
              </button>
              <button
                class="bg-primary-500 text-white px-3 py-2 text-sm lg:text-base lg:px-5 lg:py-3 rounded-lg hover:bg-primary-600 font-semibold"
                @click="routeToMentorPortal('/signin')"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Section -->
    <section class="py-12 px-8" id="faqs">
      <div class="max-w-screen-xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div class="lg:col-span-1">
            <p class="text-primary-800 font-semibold text-base lg:text-base">
              Support
            </p>
            <h3 class="text-3xl lg:text-4xl font-semibold mt-2 text-[#101828]">
              FAQs
            </h3>
            <p class="mt-5 text-gray-800 text-base lg:text-base">
              Everything you need to know about the product and billing. Can’t
              find the answer you’re looking for? Please chat to our team.
            </p>
          </div>
          <div class="lg:col-span-2 mt-5">
            <Accordion
              value="0"
              expandIcon="pi pi-plus-circle"
              collapseIcon="pi pi-minus-circle"
              class="space-y-16 lg:space-y-16"
            >
              <AccordionPanel value="0" class="px-0 lg:px-6">
                <AccordionHeader>
                  <h3
                    class="text-lg lg:text-lg font-medium -mt-1 pr-2 text-gray-900"
                  >
                    What is UniLinks?
                  </h3>
                </AccordionHeader>
                <AccordionContent>
                  <p class="mt-2 text-base lg:text-base text-gray-800">
                    UniLinks is an education platform where students can find
                    university programs, receive personalized consultation, and
                    connect with student ambassadors for real-university
                    insights.
                  </p>
                </AccordionContent>
              </AccordionPanel>
              <AccordionPanel
                class="px-0 lg:px-6"
                v-for="(faq, index) in faqs"
                :key="'faq_' + index"
                :value="index + 1"
              >
                <AccordionHeader>
                  <h3
                    class="text-lg lg:text-lg text-left -mt-1 pr-2 font-medium text-gray-900"
                  >
                    {{ faq.question }}
                  </h3>
                </AccordionHeader>
                <AccordionContent>
                  <p class="mt-2 text-base lg:text-base text-gray-800">
                    {{ faq.answer }}
                  </p>
                </AccordionContent>
              </AccordionPanel>
            </Accordion>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
